import React from 'react';
import { permissionObj } from '../../../Helpers/permission';
import EmployeeDocsTab from "./UserDocPanel/EmployeeDocsTab";
import HeadTittle from "../../../components/HeadTittle";
import ButtonIcon from "../../../components/buttons/ButtonIcon";
import {AddIcon, SettingsIcon, TrashOutlineIcon} from "../../../components/buttons/IconButtons";
import routes from "../../../Routes/routes";
import ButtonAction from "../../../components/buttons/ButtonAction";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import UserDocPanelApp from "./UserDocPanel/Functionality/UserDocPanelApp";
import AddDocumentModal from "./UserDocPanel/Modal/AddDocumentModal";
import {ACTION_MODEL} from "../../../Helpers/ActionModel";
import DeleteModal from "../../Modals/DeleteModal";

const UserDocPanel = () => {
    const { t,
        DEV,
        navigate,
        permission,
        steps,
        activeStep,
        setActiveStep,
        addDocumentModal,
        setAddDocumentModal,
        isAllChecked,
        setIsAllChecked,
        selectDocForDelete,
        deleteDocShow,
        setDeleteDocShow,
        setSelectDocForDelete,
        modified,
        setModified,
        action,
        setAction,
        item,
        setItem,
        handleStepChange,
        deleteSelectedDocuments,
        handleAction
    } = UserDocPanelApp();


    if(!DEV &&
        !permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_READ)
    ) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'user_document_management'}>
                {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_RESTRICTION_UPDATE)) && activeStep === 0 && (
                    <ButtonIcon
                        id='btn_udp_document_restriction'
                        Icon={SettingsIcon}
                        url={routes.document.restriction}
                        title={'modify_settings'}
                        iconProps={'btn-icon-svg-12px icon-color-general-00'}
                    />
                )}

                {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_CREATE)) && activeStep === 0 && (
                    <ButtonAction
                        id='btn_udp_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => setAddDocumentModal(true)}
                    />
                )}

              {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_DOCUMENT_DELETE)) && activeStep === 0 && (
                    <ButtonAction
                        id='btn_udp_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectDocForDelete?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => setDeleteDocShow(true)}
                    />
                )}
            </HeadTittle>
            <StepperTabs onlyTab={true}
                         disabled={false}
                         steps={steps}
                         activeStep={activeStep}
                         isStepOptional={() => { }} setActiveStep={setActiveStep}
                         handleStepChange={handleStepChange}>

                <StepTab index={0} activeStep={activeStep}>
                    {activeStep === 0 &&
                            <EmployeeDocsTab
                                selectDocForDelete={selectDocForDelete}
                                setSelectDocForDelete={setSelectDocForDelete}
                                isAllChecked={isAllChecked}
                                setIsAllChecked={setIsAllChecked}
                                modified={modified}
                                setModified={setModified}
                                handleAction={handleAction}
                            />
                    }
                </StepTab> 
            </StepperTabs>


            <DeleteModal
                show={deleteDocShow}
                onHide={() => setDeleteDocShow(false)}
                onClickFn={() => deleteSelectedDocuments(selectDocForDelete)}
                data={selectDocForDelete}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('documents')}
            />

            { addDocumentModal &&
                <AddDocumentModal
                    show={addDocumentModal}
                    title={ action === ACTION_MODEL.UPDATE ? t("update"):
                        action === ACTION_MODEL.READ ? t("details"):
                            t("create")
                    }
                    onHide={() => {
                        setAddDocumentModal(false);
                        setItem(null);
                        setAction(null);
                    }}
                    activeStep={activeStep}
                    setModified={setModified}
                    action={action}
                    item={item}
                />
            }
        </>
    );
};

export default UserDocPanel;
